module.exports = __webpack_public_path__ + "img/banner.20fa9828.png";